import {Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild} from '@angular/core';
import smartcrop from 'smartcrop/smartcrop';

@Component({
  selector: 'lib-profile-photo-upload',
  templateUrl: './profile-photo-upload.component.html',
  styleUrls: ['./profile-photo-upload.component.scss']
})
export class ProfilePhotoUploadComponent implements OnInit {

  @ViewChild('profilePhotoBtn') profilePhotoBtn: ElementRef;
  @ViewChild('profilePhoto') profilePhoto: ElementRef;

  @Input()
  value: string | null;

  @Output()
  valueChange = new EventEmitter<string>();

  @Input()
  loading: boolean;

  @Output()
  loadingChange = new EventEmitter<boolean>();

  @Input()
  options: {
    width: number;
    height: number;
    type: 'image/png' | 'image/jpeg' | 'image/webp';
    quality: number | undefined;
  } | null;

  constructor(
    private renderer: Renderer2,
  ) {
  }

  ngOnInit() {
    // Default options
    this.options = {
      ...{
        width: 220,
        height: 250,
        type: 'image/webp',
        quality: undefined,
      }, ...(this.options || {})
    };
  }

  changeProfilePhoto(e: any) {
    (this.profilePhotoBtn.nativeElement as HTMLElement).click();
  }

  onProfilePhotoUpload(e: any) {
    const file = e.target.files[0];
    const reader = new FileReader();
    this.loadingChange.emit(true);
    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        smartcrop.crop(img, this.options).then((result) => {
          const canvas = this.renderer.createElement('canvas') as HTMLCanvasElement;
          canvas.width = this.options.width;
          canvas.style.width = this.options.width + 'px';
          canvas.height = this.options.height;
          canvas.style.height = this.options.height + 'px';
          const ctx = canvas.getContext('2d');
          const crop = result.topCrop;

          ctx.filter = 'best';

          ctx.drawImage(img, crop.x, crop.y, crop.width, crop.height, 0, 0, canvas.width, canvas.height);

          const dataUrl = canvas.toDataURL(this.options.type);
          this.valueChange.emit(dataUrl);
          this.profilePhoto.nativeElement.src = dataUrl;

          this.loadingChange.emit(false);
        });
      };
      img.src = reader.result as string;
    };
    reader.readAsDataURL(file);
  }
}
